export const tr = {
    '0-17': '18 yaş altı',
    '18-24': '18-24',
    '25-34': '25-34',
    '35-44': '35-44',
    '45-54': '45-54',
    '55-': '55 yaş üstü',
    'all-ages': 'tüm yaşlar',
    'all-cpm-banner': "Tüm banner'lar",
    'all-genders': 'Kadın ve erkek',
    'all-items': 'Hepsi',
    'all-mobile': 'Tüm akıllı telefonlar',
    android: 'Android',
    cancel: 'İptal',
    'closed-panel-description':
        'Teklif düzenleme; teklifinizin kullanıcı özelliklerine, reklam formatına ve hatta hava koşullarına göre yükselmesini veya azalmasını sağlar.',
    'cpm-banners': "Banner'lar",
    'demography-tab': 'Cinsiyet ve yaş',
    desktops: 'Masaüstü',
    'device-tab': 'Cihazlar',
    female: 'Kadınlar',
    inbanner: "Banner'da video",
    inpage: 'Metin içerikte',
    'instream-web': 'Video akışında',
    interstitial: 'Uygulamalar',
    inventory: 'Video',
    'inventory-tab': 'Inventory',
    ios: 'iOS',
    male: 'Erkekler',
    mobile: 'Akıllı telefonlar',
    'more-info-link': 'Daha fazla bilgi',
    'no-value': 'Daha fazla trafik elde etmek için teklif düzenlemelerini belirleyin',
    'opened-panel-description':
        'Düzeltme katsayıları uygulayarak teklifi yükseltebilir veya düşürebilirsiniz. Teklif düzeltme katsayısı yüzde olarak belirtilir. Birden fazla düzenleme uygulandığında bunlar sırayla uygulanır. {moreInfoLink}',
    'panel-description':
        'Düzeltme katsayıları uygulayarak teklifi yükseltebilir veya düşürebilirsiniz. Teklif düzeltme katsayısı yüzde olarak belirtilir. Birden fazla düzenleme uygulandığında bunlar sırayla uygulanır. {moreInfoLink}',
    ready: 'Bitti',
    'retargeting-tab': 'Hedef kitle',
    rewarded: 'Ödül için video',
    'smart-banners-tab': 'Akıllı reklamlar',
    title: 'Teklif düzenlemeleri',
    'traffic-jam-tab': 'Trafik durumu',
    'video-addition-tab': 'Video eklentiler',
    'weather-tab': 'Hava'
};
